/**
 * Theme-Utility
 * Handhabt drei Modi: 'auto' | 'light' | 'dark'.
 * 'auto' folgt der OS-Einstellung (prefers-color-scheme).
 */

export const THEME_STORAGE_KEY = 'monemee_theme';
export const VALID_PREFERENCES = ['auto', 'light', 'dark'];

const DARK_MEDIA_QUERY = '(prefers-color-scheme: dark)';

export function getSystemTheme() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia(DARK_MEDIA_QUERY).matches ? 'dark' : 'light';
}

export function resolveTheme(preference) {
  if (preference === 'auto') return getSystemTheme();
  if (preference === 'dark') return 'dark';
  return 'light';
}

export function applyTheme(preference) {
  const resolved = resolveTheme(preference);
  if (resolved === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch (e) {
    // ignore
  }
}

export function getStoredPreference() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (VALID_PREFERENCES.includes(stored)) return stored;
  } catch (e) {
    // ignore
  }
  return 'auto';
}

/**
 * Registriert einen Listener auf System-Theme-Wechsel.
 * Callback wird nur aufgerufen, solange `getPreference()` 'auto' zurückgibt.
 * Gibt eine Cleanup-Funktion zurück.
 */
export function subscribeSystemTheme(getPreference, onChange) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mql = window.matchMedia(DARK_MEDIA_QUERY);
  // Defensiv: jsdom/SSR/alte Browser können hier ein partielles oder
  // fehlendes MediaQueryList liefern — dann kein Listener, kein Crash.
  if (!mql) return () => {};
  const handler = () => {
    if (getPreference() === 'auto') {
      onChange(mql.matches ? 'dark' : 'light');
    }
  };
  // Safari < 14 unterstützt nur addListener
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }
  if (typeof mql.addListener === 'function') {
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }
  return () => {};
}
